var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 86 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0002 74.6268C59.9589 74.6268 73.7067 60.6909 73.7067 43.5001C73.7067 26.3092 59.9589 12.3733 43.0002 12.3733C26.0415 12.3733 12.2937 26.3092 12.2937 43.5001C12.2937 60.6909 26.0415 74.6268 43.0002 74.6268Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2795 14.543L56.877 13.1213C56.5818 12.822 56.5818 12.2983 56.9509 11.999L65.5133 4.51658C65.8085 4.21728 66.3252 4.14246 66.6205 4.44175L68.0229 5.86341C68.3182 6.1627 68.3182 6.68647 67.9491 6.98577L59.3867 14.4682C59.0915 14.8423 58.5748 14.8423 58.2795 14.543Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6399 28.0863L73.0423 29.508C73.3376 29.8073 73.8543 29.8073 74.1495 29.4331L81.5309 20.7536C81.8262 20.4543 81.9 19.9305 81.6047 19.6312L80.2023 18.2096C79.907 17.9103 79.3903 17.9103 79.0951 18.2844L71.7137 26.964C71.4184 27.2633 71.3446 27.787 71.6399 28.0863Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4112 15.0669L71.2706 12.897C68.9824 10.5774 66.768 6.53692 69.942 3.31949C72.2302 0.999948 75.8471 0.999948 78.0615 3.31949L83.0808 8.40752C85.3691 10.7271 85.3691 14.3934 83.0808 16.6382C80.4235 19.3318 75.6995 17.3116 73.4112 15.0669Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0159 3.3194C72.2303 2.12222 75.0352 2.49634 76.9544 4.36694L82.0475 9.52979C83.8928 11.4004 84.2619 14.3185 83.0809 16.5632",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7558 14.2439C59.7558 14.2439 58.3534 15.89 60.1987 17.7606",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0088 26.5898C72.0088 26.5898 70.3849 28.0115 68.5396 26.1409",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5661 58.9137L72.9686 57.492C73.2638 57.1927 73.7805 57.1927 74.0758 57.5668L81.4572 66.2464C81.7524 66.5457 81.8262 67.0695 81.531 67.3688L80.1285 68.7904C79.8333 69.0897 79.3166 69.0897 79.0213 68.7156L71.6399 60.036C71.3447 59.7367 71.2709 59.213 71.5661 58.9137Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2058 72.4569L56.8033 73.8785C56.5081 74.1778 56.5081 74.7016 56.8771 75.0009L65.4395 82.4833C65.7348 82.7826 66.2515 82.8574 66.5467 82.5581L67.9492 81.1365C68.2444 80.8372 68.2444 80.3134 67.8754 80.0141L59.313 72.5317C59.0177 72.2324 58.501 72.1576 58.2058 72.4569Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0494 74.2526L73.19 72.0827C75.4782 69.7631 79.4641 67.5184 82.6381 70.7359C84.9263 73.0554 84.9263 76.7218 82.6381 78.9665L77.6188 84.0545C75.3306 86.3741 71.7137 86.3741 69.4993 84.0545C66.9158 81.3609 68.8349 76.5721 71.0494 74.2526Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.712 70.8105C83.893 73.0553 83.5239 75.8986 81.6786 77.844L76.5855 83.0068C74.7401 84.8774 71.8614 85.2516 69.647 84.0544",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9351 60.4101C71.9351 60.4101 70.3112 58.9884 68.4658 60.859",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6821 72.8309C59.6821 72.8309 58.2797 71.1848 60.125 69.3142",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7208 72.3822L29.1233 73.8038C29.4185 74.1031 29.4185 74.6269 29.0494 74.9262L20.4871 82.4086C20.1918 82.7079 19.6751 82.7827 19.3798 82.4834L17.9774 81.0618C17.6821 80.7625 17.6821 80.2387 18.0512 79.9394L26.6136 72.457C26.9088 72.1577 27.4255 72.0829 27.7208 72.3822Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3604 58.839L12.958 57.4173C12.6627 57.118 12.146 57.118 11.8507 57.4921L4.39556 66.0969C4.10031 66.3962 4.02649 66.92 4.32175 67.2193L5.72421 68.6409C6.01946 68.9402 6.53616 68.9402 6.83141 68.5661L14.2128 59.8865C14.5819 59.662 14.6557 59.1383 14.3604 58.839Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5889 71.8583L14.7295 74.0282C17.0177 76.3477 19.2321 80.3882 16.0581 83.6057C13.7699 85.9252 10.153 85.9252 7.93863 83.6057L2.91929 78.5176C0.631069 76.1981 0.631069 72.5317 2.91929 70.287C5.50277 67.6681 10.3007 69.6136 12.5889 71.8583Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9843 83.6805C13.7699 84.8777 10.9649 84.5035 9.04578 82.6329L3.95263 77.3953C2.10729 75.5247 1.73822 72.6065 2.91924 70.3618",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2444 72.7562C26.2444 72.7562 27.6469 71.1101 25.8015 69.2395",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9915 60.3353C13.9915 60.3353 15.6154 58.9137 17.4607 60.7843",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3606 28.0863L12.9581 29.508C12.6629 29.8073 12.1462 29.8073 11.8509 29.4331L4.46954 20.7536C4.17428 20.4543 4.10047 19.9305 4.39572 19.6312L5.872 18.2096C6.16725 17.9103 6.68395 17.9103 6.9792 18.2844L14.3606 26.964C14.6558 27.2633 14.6558 27.787 14.3606 28.0863Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7208 14.5432L29.1233 13.1216C29.4185 12.8223 29.4185 12.2985 29.0494 11.9992L20.4871 4.51682C20.1918 4.21752 19.6751 4.1427 19.3798 4.442L17.9774 5.86365C17.6821 6.16295 17.6821 6.68671 18.0512 6.98601L26.6136 14.4684C26.9827 14.7677 27.4255 14.8425 27.7208 14.5432Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8772 12.7474L12.7366 14.9173C10.4484 17.2368 6.46242 19.4816 3.28843 16.2641C1.00021 13.9446 1.00021 10.2782 3.28843 8.0335L8.30777 2.94547C10.596 0.625925 14.2129 0.625925 16.4273 2.94547C19.0846 5.56431 17.1654 10.4279 14.8772 12.7474Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28838 16.1892C2.10736 13.9445 2.47643 11.1012 4.32177 9.15577L9.48873 3.99291C11.3341 2.12232 14.2128 1.7482 16.4272 2.94538",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0652 26.5898C14.0652 26.5898 15.6891 28.0115 17.5344 26.1409",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3184 14.1692C26.3184 14.1692 27.7208 15.8153 25.8755 17.6859",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.a2f78484.svg";
export { ForwardRef as ReactComponent };